/* eslint react/no-did-mount-set-state: 0 */

import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classNames from 'classnames';

import {TextAccordion} from '../../common/text-accordion/TextAccordion';

export function mapStateToProps({config: {isRefined}, content}) {
    return {
        isRefined,
        slpText: isRefined ? content.slpRefinedText : content.slpText,
    };
}

const slpTextItem = PropTypes.shape({
    content: PropTypes.string,
    seoDescriptionType: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string,
    titleTag: PropTypes.string,
});

export class SEOTextComponent extends PureComponent {
    static propTypes = {
        baseCls: PropTypes.string,
        containerCls: PropTypes.string,
        panelIDPrefix: PropTypes.string,
        slpText: PropTypes.arrayOf(slpTextItem),
    };

    static defaultProps = {
        baseCls: 'text-accordion',
        containerCls: 'seo-text',
        panelIDPrefix: 'seo-description-type',
    };

    render() {
        const {
            baseCls,
            containerCls,
            panelIDPrefix,
            slpText,
            isRefined,
        } = this.props;

        const text = slpText.map(
            ({
                content,
                seoDescriptionType: panelID,
                type,
                title,
                titleTag,
            }) => ({
                content,
                panelID,
                type,
                title,
                titleTag,
            })
        );
        const computedContainerCls = classNames(
            {
                'module--no-margin ': !text.length,
            },
            `${isRefined ? 'refined-' : ''}${containerCls}`
        );

        return (
            <TextAccordion
                baseCls={baseCls}
                containerCls={computedContainerCls}
                panelIDPrefix={panelIDPrefix}
                text={text}
                headingStyle={isRefined ? 'dynamic' : 'span'}
            />
        );
    }
}

export const SEOText = connect(mapStateToProps)(SEOTextComponent);

SEOText.displayName = 'SEOText';

export default SEOText;
